import HayaSelect from "haya-select/src/select"
import {InputContainerContext} from "components/inputs/input-container"

export default memo(shapeComponent(class WoofHayaSelect extends ShapeComponent {
  render() {
    const inputContainerContext = useContext(InputContainerContext)
    const {selectContainerStyle, ...restProps} = this.props
    const selectContainerStyleActual = Object.assign({}, selectContainerStyle)

    if (inputContainerContext == "withinInputContainer") {
      selectContainerStyleActual.paddingTop = 17
      selectContainerStyleActual.paddingRight = 26
      selectContainerStyleActual.paddingBottom = 17
      selectContainerStyleActual.paddingLeft = 26
      selectContainerStyleActual.border = 0
      selectContainerStyleActual.background = "transparent"
    }

    return (
      <HayaSelect
        selectContainerStyle={selectContainerStyleActual}
        {...restProps}
      />
    )
  }
}))
